import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllUniversityAssignmentPricing = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);

  const [allData, setAllData] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();

  const handleAddPrice = () => {
    navigate("/assignment-pricing/add-university-assignment-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/assignment-pricing/all-university-assignment-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .get(
        `${API_BASE_URL}/pricing/assignment?courseId=${courseId}&semesterId=${semesterId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((result) => {
        console.log(result?.data?.data);
        const data = result?.data?.data;
        setAllData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (id) => {
    navigate(`/assignment-pricing/edit-university-assignment-pricing/${id}`);
  };
  return (
    <div id="chapter-inner-wrapper">
      <div className="chapter-header-div">
        <h5>All University Assignment Price</h5>
        <div className="chapter-header-btns">
          <button className="add-chapter-btn" onClick={handleAddPrice}>
            + Add Price
          </button>
          <button className="all-chapters-btn" onClick={handleViewAllPrice}>
            All Price
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Select University</label>
          <select
            className="new-chapter-dropdown"
            value={universityId}
            onChange={(e) => setUniversityId(e.target.value)}
            required
          >
            <option value="">-Select University-</option>
            {universities.map((universitie, idx) => (
              <option key={idx} value={universitie._id}>
                {universitie.universityName}
              </option>
            ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Course Name</label>
          <select
            className="new-chapter-dropdown"
            value={courseId}
            onChange={(e) => setCourseId(e.target.value)}
            required
          >
            <option value="">-Select Course-</option>
            {courses.map((course, idx) => (
              <option key={idx} value={course._id}>
                {course.courseName}
              </option>
            ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Semester</label>
          <select
            className="new-chapter-dropdown"
            value={semesterId}
            onChange={(e) => setSemesterId(e.target.value)}
            required
          >
            <option value="">-Select Semester-</option>
            {semesters.map((semester, idx) => (
              <option key={idx} value={semester._id}>
                {semester.semesterName}
              </option>
            ))}
          </select>
        </div>

        <button className="btn-save" type="submit">
          Search
        </button>
      </form>

      <div className="chapter-table-container">
        <h5>All Chapters</h5>
        <table className="chapter-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Course Name</th>
              <th>Semester</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}
            {allData &&
              allData.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item?.courseId?.courseName}</td>
                  <td>{item?.semesterId?.semesterName}</td>
                  <td>{item?.price}</td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(item?._id)}
                    ></i>
                    {/* <i className="fa-solid fa-trash-can"></i> */}
                  </td>
                </tr>
              ))}

            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllUniversityAssignmentPricing;
